import { render, staticRenderFns } from "./BetterDeals.vue?vue&type=template&id=09ac8bbd&scoped=true&"
import script from "./BetterDeals.vue?vue&type=script&lang=js&"
export * from "./BetterDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac8bbd",
  null
  
)

export default component.exports